export enum StageVehicle {
  detail = 0,
  rentalPlan = 1,
}

export enum VehicleRentalLabels {
  assemblePlan = 'Montar plano',
  add = 'Adicionar',
}
